<template>
	<div>
		<table class="datatable">
			<thead v-if="!isMobile">
			<th class="sortable active" @click="sort('name')">
				{{ nametitle }}
			</th>
			<th class="sortable" @click="sort('email')">
				E-mail
			</th>
			<th @click="sort('contactName')">
				Kontakt
			</th>
			<th class="sortable" @click="sort('address')">
				Adresse
			</th>
			<th>
				Rediger
			</th>
			</thead>
			<tbody v-if="!isMobile">
				<tr v-for="(customer, index) in (sortedActivity, filteredList)" :key="index" @click="showCustomer(customer)" :title="customer.notes ? 'Noter: ' + customer.notes : null">
					<td>
						{{ customer.name }}
					</td>
					<td>
						{{ customer.email }}
					</td>
					<td>
						{{ customer.contactname }}
					</td>
					<td>
						{{ customer.address }}
						{{ customer.cityandzipcode }}
					</td>
					<td>
						<RouterLink :to="{ name: 'CustomerEdit', params: { customerid: customer.id }}">
							Rediger
						</RouterLink>
					</td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr v-for="(customer, index) in (sortedActivity, filteredList)" :key="index" @click="showCustomer(customer)">
					<td>
						<ul class="flex-content">
							<li data-label="Kunde">{{ customer.name }}</li>
							<li data-label="E-mail">{{ customer.email }}</li>
							<li data-label="Kontakt">{{ customer.contactname }}</li>
							<li data-label="Adresse">{{ customer.address }}{{ customer.cityandzipcode }}</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
		<div v-if="(data && data.length > 0) && (filteredList && filteredList.length == 0) && !isComponentBusy">
			Ingen institutioner fundet
		</div>
		<div v-if="(data == null || data.length == 0) && !isComponentBusy">
			Der er endnu ikke oprettet nogen institutioner
		</div>
		<transition name="fade">
			<div class="busyloader" v-if="isComponentBusy"><div><div></div><div></div><div></div><div></div></div></div>
		</transition>
	</div>
</template>

<script>
	import { types } from "@/app/types/types";

	export default {
		name: "CustomersList",
		data: () => ({
			data: [],
			currentSort: "name",
			currentSortDir: "asc",
			searchSelection: "",
			pageSize: 10000,
			currentPage: 1
		}),
		props: ["search", "section"],
		computed:
		{
			nametitle()
			{
				return this.section == "orders" ? "Institution" : "Navn"
			},
			isMobile()
			{
				return this.$mq !== "tablethori" && this.$mq !== "desktop"
			},
			sortedActivity: function ()
			{
				var customers = this.data
				return customers.sort((a, b) =>
				{
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			},
			filteredList()
			{
				var customers = this.data
				return customers.filter((data) =>
				{
					let name = data.name.toLowerCase().match(this.search.toLowerCase());
					let email = data.email.toLowerCase().match(this.search.toLowerCase());
					let contact = data.contactname.toLowerCase().match(this.search.toLowerCase());
					let address = data.address.toLowerCase().match(this.search.toLowerCase()) || data.cityandzipcode.toLowerCase().match(this.search.toLowerCase());
					return name || email || contact || address;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			}
		},
		watch:
		{
			"$route": "loadData"
		},
		created()
		{
			this.loadData()
		},
		methods:
		{
			async loadData()
			{
				this.setComponentAsBusy()
				await this.$store.dispatch(types.ACTION_GET_CUSTOMERS)
					.then(response =>
					{
						this.data = response.data;
						this.setComponentAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("CustomersList.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
					});
			},
			showCustomer(customer)
			{
				if ((!this.section || this.section == "customers") && (this.$route.name != "CustomerEdit"))
				{
					// this.$router.push({ name: "PersonGroups", params: { customerid: customer.id } })
					this.$router.push({ name: "Agreements", params: { customerid: customer.id } })
				}
				else if (this.section == "orders")
				{
					this.$emit("update", { customername: customer.name })
					this.$router.push({ name: "OrdersPersonGroups", params: { customerid: customer.id } })
				}
			},
			sort: function (s)
			{
				if (s === this.currentSort)
				{
					this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
				}
				this.currentSort = s;
			},
			nextPage: function ()
			{
				if ((this.currentPage * this.pageSize) < this.data.length) this.currentPage++;
			},
			prevPage: function ()
			{
				if (this.currentPage > 1) this.currentPage--;
			}
		}
	}
</script>
